module.exports = __webpack_public_path__ + "img/bank-card.6a705e83.svg";